import React from 'react';
import './ConfirmDialog.css';
import type { ConfirmConfig } from '../../types';

interface ConfirmDialogProps {
  config: ConfirmConfig | null;
  onClose: () => void;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ config, onClose }) => {
  if (!config) return null;

  const handleConfirm = () => {
    config.onConfirm();
    onClose();
  };

  return (
    <div className="confirm-overlay" onClick={onClose}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <h3 className="confirm-title">{config.title}</h3>
        <p className="confirm-message">{config.message}</p>
        <div className="confirm-actions">
          <button className="confirm-btn confirm-btn--cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className={`confirm-btn confirm-btn--confirm ${config.danger ? 'confirm-btn--danger' : ''}`}
            onClick={handleConfirm}
          >
            {config.confirmLabel || 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
};
